export class ApiResponse {
    statusCode: any;
    reasonPhrase: string;
    isSuccess: boolean;
    data: any;

    constructor() {
        this.statusCode = 0;
        this.reasonPhrase = '';
        this.isSuccess = false;
        this.data = {};
    }
}


// WEBPACK FOOTER //
// ./app/admin/apiresponse.ts